import type { AppVersion } from './version-check.service';

/** A deploy changes the build number even when the release version stays the same. */
export function isDifferentBuild(local: AppVersion, latest: AppVersion): boolean {
  return local.version !== latest.version || local.buildNumber !== latest.buildNumber;
}

/** Shows the build number when both sides share a version, so the banner never reads "0.1.0 → 0.1.0". */
export function formatAppVersion(version: AppVersion | undefined, other: AppVersion | undefined): string {
  if (!version?.version) return version?.buildNumber || '—';
  return version.version === other?.version && version.buildNumber
    ? `${version.version} (${version.buildNumber})`
    : version.version;
}
